<template>
    <span>
        <a href="" @click.prevent="toggle">{{ toggleText }} <i :class="`fas fa-caret-${is_open ? 'up' : 'down'}`"></i></a>
        <div :class="{ 'toggle-content': true, 'open': is_open }">
            <slot></slot>
        </div>
    </span>
</template>

<script>
export default {
    props: {
        toggleText: String
    },
    data() {
        return {
            is_open: false
        }
    },
    methods: {
        toggle() {
            this.is_open = !this.is_open
        }
    }
}
</script>


<style>
.toggle-content {
    overflow: hidden;
    max-height: 0px;
    transition: max-height;
    transition-duration: 500ms;
    transition-delay: 0;
}

.toggle-content.open {
    max-height: 600px;  /* Nice way to allow the css trasition of the height of the box to the height of the content. Limitation: height of content should be no bigger than 600px */
}
</style>
